import React from 'react';
import { styled } from '@compiled/react';
import { N600 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { AiIcon } from '@atlassian/jira-atlassian-intelligence';
import { AI_BRANDNAME } from '@atlassian/jira-atlassian-intelligence/src/common/constants';
import { gridSize } from '@atlassian/jira-common-styles/src';
import { useIntl } from '@atlassian/jira-intl';
import { ModalTitle } from '@atlassian/jira-minimizable-modal';
import messages from './messages';

export const AiEnabledModalTitle = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<AiIcon size="medium" label={AI_BRANDNAME} />
			<AiModalTitle data-testid="issue-create.common.ui.ai-enabled.ai-enabled-title.ai-enabled-modal-title">
				{formatMessage(messages.aiEnabledMiniTitle)}
			</AiModalTitle>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AiModalTitle = styled(ModalTitle)({
	display: '-webkit-box',
	color: token('color.text', N600),
	fontSize: '14px',
	fontWeight: 300,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `0 ${gridSize}px`,
	WebkitLineClamp: 2,
	WebkitBoxOrient: 'vertical',
	whiteSpace: 'normal',
	textOverflow: 'normal',
	overflow: 'hidden',
	flexGrow: 1,
});
